import React, {useContext, useEffect, useState, useRef, useCallback} from 'react';
import {
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    TextField
} from '@mui/material';
import ReactQuill from 'react-quill'
import {useParams} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {SectionService, StatementService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import {NotificationContext} from "../../../components/NotificationContext";
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import { useHistory } from 'react-router-dom';
import Prompt from "../../../customUtil/Prompt";
import _ from "lodash";

const StatementCreateForm = () => {
        const methods = useForm();
        const history = useHistory();
        const {showMessage} = useContext(NotificationContext);
        const [data, setData] = useState({content: '', statementChildren: []});
        const [tempData, setTempData] = useState({content: '', statementChildren: []});
        const [sections, setSections] = useState([]);
        const [open, setOpen] = useState(false);
        const [isReady, setIsReady] = useState(false);
        const [statements, setStatements] = useState([]);
        const [content, setContent] = useState('');
        const [tempContent, setTempContent] = useState('')
        const [block, setBlock] = useState(false);  
        const [newPage, setNewPage] = useState(false);
        const refSubmitButtom = useRef();
        const [pressed, setPressed] = useState(false)

        const handleGoToIntendedPage = useCallback(
            (location) => history.push(location),
            [history]
          );

        const [triggerExit, setTriggerExit] = useState({
            onOk: false,
            path: ""
          });

       const [isVisibleDialog, setVisibleDialog] = useState(false);
        const {id} = useParams();

        const handleClose = () => {
            setOpen(false);
        }

        const removeChild = (child) => {
            setBlock(true);
            let newData = {...data};
            newData.statementChildren = data.statementChildren.filter((s) => child.childStatementId !== s.childStatementId);
            setData(newData);
        }

        const refreshStatements = (sectionId) => {
            StatementService
                .getAvailableStatementsFor(sectionId, data.id)
                .then((response) => {
                    setStatements(response.data);
                });
        }

        const addStatement = (statement) => {
            setBlock(true);
            let newData = {...data};
            newData.statementChildren.push({
                statementId: data.id,
                childStatementId: statement.id,
                statementOrder: 1,
                childStatement: statement
            });
            setData(newData);
            setTempData(tempData);
            setOpen(false);
        }


      const resetFormToInitial = () => {
           setData({           
            allContent : [],
            content: '',
            id: undefined,
            sectionId: undefined,
            statementChildren: []           
        });
           setTempContent('');
           setContent('')
           setNewPage(true);
         }

        useEffect(() => {
            if(data.sectionId !== tempData.sectionId){
                setBlock(true)
            }        
            if (data.sectionId !== undefined) {
                refreshStatements(data.sectionId);
            }   
          }, [data])

        useEffect(() => {
            SectionService.getAll().then((response) => {
                const statementSections = response.data.filter(s => s.allowStatements);
                setSections(statementSections);
            });

                resetFormToInitial();
                setIsReady(true);
           
        }, [id]);
  
       
        const triggerSubmit = () => {
            refSubmitButtom?.current?.click();
          };     
       
          const onSave = (event) => {
              triggerSubmit();
              setBlock(false);
              setVisibleDialog(false);
          }
      
          const checkModified = (event) => {
              if(event.type ===  "change"){
                  setBlock(true);
                     }
              if(data.content !== content){
                  setBlock(true);
              }
                  }

                  useEffect(() => {
                    window.onpopstate = e => {
                        setPressed(true)
                    };
                  }); 

          useEffect(() => {   
            
            //handle block navigate if form is dirty
            if(pressed){
                history.goBack();
              }
            const unblock = history.block((location) => {
              if (location.pathname !== '/templates/statements/new') {
                if(block || content !== tempContent){
                    setVisibleDialog(true);   
                    setTriggerExit({...triggerExit, path: location.pathname});
                }
                else
                    {
                    setVisibleDialog(false);   
                    setTriggerExit({onOk: true, path: location.pathname});
                }                                         
                  }             
              if (triggerExit.onOk) {
                return true;
              }
              return false;
            });
            if (triggerExit.onOk) {
                handleGoToIntendedPage(triggerExit.path);
                setBlock(false)
              }
            return () => {
              unblock();             
            };        
          }, [pressed, history, triggerExit.onOk, triggerExit.path, block, content, tempContent]);

        const {handleSubmit, control, errors} = methods;

        // const handleNavigation = () => {
        //   history.push('/templates/statement/new')            
        // }

        const onSubmit = d => {            
            setBlock(false);
            setTriggerExit({...triggerExit, onOk: true})
            setTempContent(content);
            setPressed(false);
            setVisibleDialog(false); 
            let newContent = (content === '<p><br></p>')? '' : content;
                setIsReady(false);
            
                    StatementService.create({...data, ...d, content: newContent}).then((response) => {
                        setData(response.data);
                        showMessage('Statement Created.', 'success');
                    }).catch((err) => {
                        showMessage(err.message, 'error');
                    });
                
                setTimeout(() => {
                    setIsReady(true);
                    history.push('/templates/statements')                    
                }, 100)                
                    };

        if (!isReady) {
            return (
                <CircularProgress/>
            );
        }
        return (
            <Container>
                <header>
                    <h1>Statement</h1>
                </header>               
                <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
                <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Controller
                        name="title"
                                control={control}
                                as={TextField}
                                fullWidth
                                label="Title"
                                rules={{required: 'Title is required.'}}
                                color="primary"
                                variant="standard"
                                key={data.title}
                                defaultValue={data.title}
                                onChange={() => setData({...data, title: data.title})}
                            />
                         
                            <ValidationError error={errors.title}/>
                        </Grid>
                        <Grid item xs={8}>
                            <br/>
                            <div className="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth">
                                <label
                                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                                    data-shrink="true">Content</label>
                            </div>
                            <FormControl label="Content" variant="outlined">

                                <ReactQuill value={content}
                                    onChange={setContent} />

                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel label="Section"
                                              htmlFor="sectionId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                                              
                            <Controller
                                control={control}
                                name="sectionId"
                                rules={{required: 'Section is required.'}}
                                defaultValue={data.sectionId}
                                key={data.sectionId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={sections.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.title}
                                        })}
                                        onChange={value => {
                                            onChange(value.value);
                                            setData({...data, sectionId: value.value})
                                        }}
                                        options={sections.map(p => ({value: p.id, label: p.title}))}
                                    />
                                }
                            />
                            <ValidationError error={errors.sectionId}/>
                        </Grid>
                        <Grid item xs={12}>
                            <b>Children</b>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" type="button"
                                disabled={!data.sectionId}    onClick={() => setOpen(true)}>Add</Button>
                            <hr/>

                            <table>
                                {data.statementChildren.filter(c => c.childStatement.allContent !== '').map((c) => {
                                    return <tr>
                                        <td>*</td>
                                        <td>
                                            <span dangerouslySetInnerHTML={{__html: c.childStatement.allContent}}></span>
                                        </td>
                                        <td>
                                            <IconButton size="small" aria-label="delete" onClick={() => removeChild(c)}>
                                                <DeleteIcon color="error"/>
                                            </IconButton>
                                        </td>
                                    </tr>
                                })}
                            </table>

                            {data.statementChildren.length === 0 && <>No Child Statements set under this.</>}

                            <hr/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                    </Grid>
                    <button hidden={true} ref={refSubmitButtom} type={"submit"} />
                </form>
                <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add statement</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please add the statement here.
                        </DialogContentText>
                        <table>
                            <thead>
                            <tr>
                                <th></th>
                                <th>Title</th>
                            </tr>
                            </thead>
                            <tbody>
                            {statements.map((s) => {
                                return <tr id={s.id}>
                                    <td><Button variant="contained"
                                                color="primary"
                                                type="button"
                                                onClick={() => addStatement(s)}>Add</Button></td>
                                    <td>{s.title}</td>

                                </tr>
                            })}

                            </tbody>
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        );
    }
;

export default StatementCreateForm;
